(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["able-react"] = factory();
	else
		root["able-react"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 4184:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 5545:
/***/ (() => {



/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_Column)
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: external "react/jsx-runtime"
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
;// CONCATENATED MODULE: ./src/Column/Column.tsx


/**
 * A Column is a subset of the Grid component that allows you to place child elements
 * within Columns in a Grid.
 *
 * @version 1.0.0
 */

function Column(props) {
  var className = props.className,
    children = props.children,
    cols = props.cols,
    offset = props.offset,
    vxs = props.vxs,
    vxsOffset = props.vxsOffset,
    vsm = props.vsm,
    vsmOffset = props.vsmOffset,
    vmd = props.vmd,
    vmdOffset = props.vmdOffset,
    vlg = props.vlg,
    vlgOffset = props.vlgOffset,
    bsm = props.bsm,
    bsmOffset = props.bsmOffset,
    bmd = props.bmd,
    bmdOffset = props.bmdOffset,
    blg = props.blg,
    blgOffset = props.blgOffset;
  var classes = classnames_default()('able-column', cols ? "cols-".concat(cols) : undefined, offset ? "offset-".concat(offset) : undefined, vxs ? "vxs-cols-".concat(vxs) : undefined, vxsOffset ? "vxs-offset-".concat(vxsOffset) : undefined, vsm ? "vsm-cols-".concat(vsm) : undefined, vsmOffset ? "vsm-offset-".concat(vsmOffset) : undefined, vmd ? "vmd-cols-".concat(vmd) : undefined, vmdOffset ? "vmd-offset-".concat(vmdOffset) : undefined, vlg ? "vlg-cols-".concat(vlg) : undefined, vlgOffset ? "vlg-offset-".concat(vlgOffset) : undefined, bsm ? "bsm-cols-".concat(bsm) : undefined, bsmOffset ? "bsm-offset-".concat(bsmOffset) : undefined, bmd ? "bmd-cols-".concat(bmd) : undefined, bmdOffset ? "bmd-offset-".concat(bmdOffset) : undefined, blg ? "blg-cols-".concat(blg) : undefined, blgOffset ? "blg-offset-".concat(blgOffset) : undefined, className || undefined);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    className: classes,
    children: children
  });
}
Column.defaultProps = {
  className: undefined,
  cols: undefined,
  offset: undefined,
  vxs: undefined,
  vxsOffset: undefined,
  vsm: undefined,
  vsmOffset: undefined,
  vmd: undefined,
  vmdOffset: undefined,
  vlg: undefined,
  vlgOffset: undefined,
  bsm: undefined,
  bsmOffset: undefined,
  bmd: undefined,
  bmdOffset: undefined,
  blg: undefined,
  blgOffset: undefined
};
/* harmony default export */ const Column_Column = (Column);
// EXTERNAL MODULE: ./src/Column/Column.scss
var src_Column_Column = __webpack_require__(5545);
;// CONCATENATED MODULE: ./src/Column/index.ts


/* harmony default export */ const src_Column = (Column_Column);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});